import { createSlice } from "@reduxjs/toolkit";
import { getRoleList } from "../../reduxApi/admin/Role";

const roleSlice = createSlice({
    name: 'role',
    initialState: {
        status: 'idel',
        isFiltered: false,
        role: [],
    },
    reducers: {
        setFilteredStatus: (state, action) => {
            state.isFiltered = action.payload;
        },
        deleteRoleAction: (state, action) => {
            action.payload.forEach((id) => {
                const index = state.role.findIndex((item) => item.ROWID === id);
                if (index !== -1) {
                    state.role.splice(index, 1);
                }
            });
        },
        updateRoleAction: (state, action) => {
            console.log("action.payload in updateRoleAction:", action.payload.ROWID);
            console.log("Current state.role:", state.role);
            const index = state.role.findIndex((item) => item.ROWID === action.payload.ROWID)
            console.log("index",index);
                        
            if (index != -1) {
                state.role.splice(index, 1,  action.payload )
            }
        },
        addRoleAction: (state, action) => {
         console.log("action--->",action.payload);
         state.role.unshift(action.payload);
            
        
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getRoleList.pending, (state, action) => {
            state.status = 'pending'
        })
            .addCase(getRoleList.fulfilled, (state, action) => {
                state.status = 'fulfilled'
                state.role = action.payload.data.roles;
            })
    }
})
export const { deleteRoleAction, updateRoleAction, addRoleAction, setFilteredStatus } = roleSlice.actions
export default roleSlice.reducer